@if (workflow && !errorMessage) {
    <!-- header -->
    <div class="mx-2">
        <adapt-display-workflow-outcome-header [workflow]="workflow"
                                               [showStartButton]="true"
                                               [skipOutcomeStep]="true"
                                               [startWorkflow$]="startWorkflow$"
                                               (isCompleted)="onWorkflowCompletionStatus($event)"></adapt-display-workflow-outcome-header>
    </div>
    <!-- completed pathway -->
    @if (workflow.wrapUpSlug && isCompleted) {
        <div class="mx-3 mt-3">
            <adapt-workflow-journey-wrap-up-card [workflow]="workflow"></adapt-workflow-journey-wrap-up-card>
        </div>
    }
    <!-- article -->
    @if (workflow.articleSlug) {
        <div class="outcomes-card px-3 py-3">
            <dx-scroll-view>
                <adapt-implementation-kit-content [articleId]="workflow.articleSlug"> </adapt-implementation-kit-content>
            </dx-scroll-view>
        </div>
    }
} @else {
    <div class="alert alert-danger"
         role="alert">
        {{ errorMessage ?? "Unknown pathway" }}
    </div>
}
